import React from 'react';
import { withStyles, Grid, ButtonBase } from '@material-ui/core';
import { styles } from './styles';
import { StyledComponentProps } from '@material-ui/core/styles';
import { contact } from '../../../../model/contact';
import DefaultImg from '../../../../images/client-no-image.png'
interface IProps extends StyledComponentProps {
    contact: contact;
}
const Avatar = (props: IProps) =>{
    const uri = props.contact && props.contact.pictureUri ? props.contact.pictureUri : DefaultImg;
    return (
    <Grid item className={props.classes.root}>
        <ButtonBase className={props.classes.imageContainer}>
            <img className={props.classes.image} alt={`${props.contact.name} ${props.contact.surname}`} src={uri} />
        </ButtonBase>
    </Grid>)
}
export default withStyles(styles)(Avatar)